import React from 'react'
import Container from '../containerComp/Container'
import { EWSPropsTypes } from './EWSTypes'

const EWS = (props: EWSPropsTypes) => {
    return (
        <Container title='EWS'>
            
        </Container>
    )
}

export default EWS